import { render } from "./access-denied.vue?vue&type=template&id=54ca3662"
import script from "./access-denied.vue?vue&type=script&setup=true&lang=js"
export * from "./access-denied.vue?vue&type=script&setup=true&lang=js"

import "./access-denied.vue?vue&type=style&index=0&id=54ca3662&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/access-denied/access-denied.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54ca3662"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54ca3662', __exports__)) {
    api.reload('54ca3662', __exports__)
  }
  
  module.hot.accept("./access-denied.vue?vue&type=template&id=54ca3662", () => {
    api.rerender('54ca3662', render)
  })

}


export default __exports__